import {
    COMMISSIONS_GENERATE_EXCEL_BEGIN,
    COMMISSIONS_GENERATE_EXCEL_SUCCESS,
    COMMISSIONS_GENERATE_EXCEL_FAILURE
  } from '../constants'
  
  export function reducer(state, action) {
    switch (action.type) {
      case COMMISSIONS_GENERATE_EXCEL_BEGIN:
        return {
          ...state,
          commissionList: {
            ...state.commissionList,
            reportPending: true,
            reportSuccess: false,
            errorMessage: null
          }
        }
      case COMMISSIONS_GENERATE_EXCEL_SUCCESS:
        return {
          ...state,
          commissionList: {
            ...state.commissionList,
            reportPending: false,
            reportSuccess: true,
            errorMessage: null
          }
        }
  
      case COMMISSIONS_GENERATE_EXCEL_FAILURE:
        return {
          ...state,
          commissionList: {
            ...state.commissionList,
            reportPending: false,
            reportError: true,
            reportSuccess: false,
            errorMessage: action.data
          }
        }
      default:
        return state
    }
  }
  